// extracted by mini-css-extract-plugin
module.exports = {"LayerPanel":"LayerPanel_LayerPanel__3tPrK","header":"LayerPanel_header__3kMdx","actionButton":"LayerPanel_actionButton__3wSs7","iconClose":"LayerPanel_iconClose__8rLMJ"};